"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _lhJsEmailContentLib = require("@lifehikes/lh-js-email-content-lib");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _SupportedPlaceholders = _interopRequireDefault(require("./SupportedPlaceholders.vue"));
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'HikeEmailSetting',
  components: {
    Tinymce: _Tinymce.default,
    SupportedPlaceholders: _SupportedPlaceholders.default
  },
  props: {
    parentId: {
      type: String,
      default: ""
    },
    parentAutomatedEmail: {
      type: Array,
      default: []
    },
    parentEmailRuleSet: {
      type: String,
      default: _lhJsEmailContentLib.ruleSetNames.HIKE_EMAIL_RULE_SET_NO_EMAIL
    },
    parentRelatedLoops: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      hikeRuleSets: _lhJsEmailContentLib.hikeRuleSets,
      ruleSet: _lifehikesInitData.RuleSet,
      emailRuleSet: "",
      emailSetting: []
    };
  },
  computed: {
    haveLoop: function haveLoop() {
      return Array.isArray(this.parentRelatedLoops) && this.parentRelatedLoops.length > 0;
    }
  },
  watch: {
    emailRuleSet: {
      handler: function handler(newVal) {
        this.passBackToParent(newVal, "ruleSet");
      },
      deep: true
    },
    emailSetting: {
      handler: function handler(newVal) {
        var newEmailSetting = newVal.map(function (p) {
          return {
            ruleName: p.name,
            subject: p.defaultSubject,
            content: p.defaultContent
          };
        });
        console.info('newEmailSetting');
        console.info(newEmailSetting);
        this.passBackToParent(newEmailSetting, "emailSetting");
      },
      deep: true
    }
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (_this.parentEmailRuleSet === "" || _this.parentEmailRuleSet === null) {
              _this.emailRuleSet = _lhJsEmailContentLib.ruleSetNames.HIKE_EMAIL_RULE_SET_NO_EMAIL;
            } else {
              _this.emailRuleSet = _this.parentEmailRuleSet;
            }
            _this.initEmailSetting(false);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    initEmailSetting: function initEmailSetting(refreshEditor) {
      var _this2 = this;
      this.emailSetting = [];
      var selectRule = this.emailRuleSet;
      var hikeRuleSets = this.hikeRuleSets[selectRule];
      console.info(selectRule);
      console.info(hikeRuleSets);
      hikeRuleSets.forEach(function (item) {
        var emailSetting = (0, _lhJsEmailContentLib.getEmailRuleSettings)(item);
        var parentEmailSetting = _this2.parentAutomatedEmail.find(function (p) {
          return p.ruleName === item;
        });
        if (parentEmailSetting !== null && parentEmailSetting !== undefined) {
          emailSetting.defaultSubject = parentEmailSetting.subject;
          emailSetting.defaultContent = parentEmailSetting.content;
        }
        emailSetting.name = item;
        emailSetting.showPlaceholders = false;
        var remarks = '';
        if (_this2.haveLoop) {
          if (!emailSetting.enableWhenHikeInLoop) {
            remarks = "It will not trigger because the Hike is within a Loop.";
          }
        } else {
          if (!emailSetting.enableWhenHikeNotInLoop) {
            remarks = "It will not trigger because the Hike is not within a Loop.";
          }
        }
        emailSetting.remarks = remarks;
        console.log(emailSetting);
        _this2.emailSetting.push(emailSetting);
      });
      if (refreshEditor) {
        this.$nextTick(function () {
          return _this2.emailSetting.forEach(function (item, index) {
            console.info('当前---------------：' + index);
            //console.info(item.defaultContent);
            _this2.resetSubjectContent(item.name, index);
          });
        });
      }
      console.log(this.emailSetting);
    },
    ruleSettingChange: function ruleSettingChange() {
      this.initEmailSetting(true);
    },
    resetSubjectContent: function resetSubjectContent(name, index) {
      //console.info('当前name---------------：' + name)
      var defaultEmailSetting = (0, _lhJsEmailContentLib.getEmailRuleSettings)(name);
      var currentSetting = this.emailSetting[index];
      //console.info('defaultEmailSetting---------------：' + defaultEmailSetting)
      //console.info('currentSetting---------------：' + currentSetting)
      currentSetting.defaultSubject = defaultEmailSetting.defaultSubject;
      currentSetting.defaultContent = defaultEmailSetting.defaultContent;
      //this.$set(this.emailSetting, index, currentSetting)
      //Fixed the tinymce editor reset update ui bug
      this.$nextTick(function () {
        var editor = window.tinymce && window.tinymce.get("descriptionEditor" + index);
        if (editor) {
          return editor.setContent(currentSetting.defaultContent || "");
        } else {
          console.warn("TinyMCE editor instance not found yet for ID: descriptionEditor" + index);
        }
      });
    },
    switchPlaceholders: function switchPlaceholders(showPlaceholders, index) {
      var currentSetting = this.emailSetting[index];
      currentSetting.showPlaceholders = showPlaceholders;
    },
    passBackToParent: function passBackToParent(res, type) {
      this.$emit("updateParentEmailRuleSet", res, type);
    }
  }
};